import { computed, Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LoaderService {
  private readonly requests = signal(0);
  readonly isLoaderVisible = computed(() => this.requests() > 0);

  addRequest(): void {
    this.requests.update((value) => ++value);
  }

  removeRequest(): void {
    this.requests.update((value) => --value);
  }
}
